import React from "react";
import Update from "modules/rejectionReasons/components/Update";

const RejectionReasonsUpdatePage = () => {
  return <Update />;
};

export default RejectionReasonsUpdatePage;
